import client from "./client";

export const login = async (
  username: string,
  password: string
): Promise<any> => {
  return await client
    .post("/auth/login-2fa", { username, password })
    .then(response => response.data.response);
};

export const validateMfa = async (
  mfaToken: string,
  code: string
): Promise<any> => {
  return await client
    .post("/auth/mfa/validate", { mfaToken, code })
    .then(response => response.data.response);
};

export const validateBackupCode = async (
  mfaToken: string,
  backupCode: string
): Promise<any> => {
  return await client
    .post("/auth/mfa/validate-backup", { mfaToken, backupCode })
    .then(response => response.data.response);
};
